import { Box, Typography, Button, Chip, Stack } from "@mui/material";
import { FilterAlt as FilterAltIcon } from '@mui/icons-material';
import 'moment/locale/pt-br';
import moment, { Moment } from 'moment';
import PaperMUI from "../../../../../components/PaperMUI";
import { useQuery } from "react-query";
import axiosClient from "../../../../../lib/axios";
import GraficoLineEstatistica from "./GraficoLineEstatistica";
import { useState } from "react";
import { PesquisarFluxo } from "../../../../../types/mutations/bpm/pesquisar-fluxo";
import FiltrosModal from './FiltrosModal';

export default function CardCobrancas() {
    const [dataInicial, setDataInicial] = useState<Moment | null>(moment().subtract(6, 'months'));
    const [dataFinal, setDataFinal] = useState<Moment | null>(moment());
    const [selectedFluxoId, setSelectedFluxoId] = useState<number | null>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const { data: pesquisarFluxoResponse } = useQuery({
        queryKey: ["pesquisar-fluxos"],
        queryFn: async () => {
            const response = await axiosClient.get(`pesquisar-fluxos`, {
                params: { modulo: 'Financeiro' }
            });
            return response.data;
        },
    });

    const modeloFluxo: PesquisarFluxo[] = Array.isArray(pesquisarFluxoResponse)
        ? pesquisarFluxoResponse
        : (pesquisarFluxoResponse?.data ?? []);
    const fluxoId: number | null =
        typeof selectedFluxoId === 'number'
            ? selectedFluxoId
            : (modeloFluxo[0]?.id ?? null);

    const handleOpenModal = () => setIsModalOpen(true);
    const handleCloseModal = () => setIsModalOpen(false);

    const handleFluxoChange = (id: number) => {
        setSelectedFluxoId(id);
    };
    const handleApply = () => {
        setIsModalOpen(false);
    };
    const handleDataChange = (inicial: Moment | null, final: Moment | null) => {
        setDataInicial(inicial);
        setDataFinal(final);
    };

    const dataInicialFormatada = dataInicial ? dataInicial.format('YYYY-MM-DD') : '';
    const dataFinalFormatada = dataFinal ? dataFinal.format('YYYY-MM-DD') : '';

    const { data: resultEstatiticaFluxo, isLoading } = useQuery({
        queryKey: ["estatisticas-fluxo", fluxoId, dataInicialFormatada, dataFinalFormatada],
        queryFn: () =>
            axiosClient.get(
                `estatisticas-fluxo/${fluxoId}?data_inicial=${dataInicialFormatada}&data_final=${dataFinalFormatada}`
            ),
        enabled: fluxoId != null && !!dataInicialFormatada && !!dataFinalFormatada
    });

    return (
        <PaperMUI>
            <Box p={2} mb={2} gap={2} display="flex" flexDirection='column'>
                <Box display="flex" alignItems="center" gap={1} sx={{ justifyContent: 'space-between' }}>
                    <Typography variant='h6'>Estatísticas do Fluxo</Typography>
                    <Button
                        variant="outlined"
                        startIcon={<FilterAltIcon />}
                        onClick={handleOpenModal}
                    >
                        Filtros
                    </Button>
                </Box>

                <Stack direction="row" spacing={1} flexWrap="wrap" gap={1}>
                    {fluxoId != null && (
                        <Chip
                            label={`Fluxo: ${modeloFluxo.find((f) => f.id === fluxoId)?.nome ?? ''}`}
                            variant="outlined"
                            size="small"
                        />
                    )}
                    {dataInicial && dataFinal && (
                        <Chip
                            label={`Período: ${dataInicial.format('DD/MM/YYYY')} - ${dataFinal.format('DD/MM/YYYY')}`}
                            variant="outlined"
                            size="small"
                        />
                    )}
                </Stack>

                <FiltrosModal
                    onApply={handleApply}
                    open={isModalOpen}
                    onClose={handleCloseModal}
                    modeloFluxo={modeloFluxo}
                    fluxoId={fluxoId}
                    dataInicial={dataInicial}
                    dataFinal={dataFinal}
                    onFluxoChange={handleFluxoChange}
                    onDataChange={handleDataChange}
                />

                <GraficoLineEstatistica
                    data={resultEstatiticaFluxo?.data}
                    isLoading={isLoading}
                />
            </Box>
        </PaperMUI>
    )
}